export default __webpack_public_path__ + "static/media/shopify.530266f5.png";